import { Injectable } from '@angular/core';

import {
  Ordem,
  OrdemInclusao,
  OrdemBaixa,
  OrdemHistorico,
  OrdemEndereco,
  OrdemRevogacao,
  OrdemOutros
} from '../model/ordem';
import { Titular } from '../model/titular';
import { DateUtils } from 'src/app/shared/util/date-utils';
import { Credor } from '../model/credor';
import { Arquivo } from '../model/arquivo';
import { TipoOrdem } from '../model/enum/tipo-ordem.enum';

@Injectable({
  providedIn: 'root'
})
export class OrdemBuilderService {

  static DESCRICAO_REVOGACAO = "Considerando a revogação da decisão judicial anteriormente proferida nestes autos, determino que a base de dados da Serasa Experian seja restabelecida à sua condição original, com a reinclusão da(s) referida(s) anotação(ões).";

  public buildInclusao(nroProcesso: string, titulares: Titular[], form: any): OrdemInclusao {
    const base = this.buildBase(nroProcesso, titulares, form, TipoOrdem.ACAO);
    return {
      ...base,
      dadosOrdem: {
        valorAnotacao: form.vlrAcao,
        nomeAutor: form.autor,
        nomeReu: form.reu,
        nomeCredor: form.autor,
        cartaComunicado: form.cartaComunicado
      }
    };
  }

  public buildBaixa(nroProcesso: string, titulares: Titular[], form: any, credores: Credor[]): OrdemBaixa {
    const base = this.buildBase(nroProcesso, titulares, form, TipoOrdem.BAIXA);
    return {
      ...base,
      dadosOrdem: {
        credores,
        nomeAutor: form.autor,
        nomeReu: form.reu
      }
    };
  }

  public buildHistorico(nroProcesso: string, titulares: Titular[], form: any): OrdemHistorico {
    const base = this.buildBase(nroProcesso, titulares, form, TipoOrdem.HISTORICO);
    const initDate = new Date();
    const finalDate = new Date();
    const subtractedDate = DateUtils.minusYears(initDate, form.anosHistorico);
    const [periodoInicial] = DateUtils.truncate(subtractedDate);
    const [periodoFinal] = DateUtils.truncate(finalDate);

    return {
      ...base,
      dadosOrdem: {
        periodoInicial,
        periodoFinal
      }
    };
  }

  public buildEndereco(nroProcesso: string, titulares: Titular[], form: any): OrdemEndereco {
    const base = this.buildBase(nroProcesso, titulares, form, TipoOrdem.CEND);
    return {
      ...base,
      dadosOrdem: {}
    };
  }

  public buildRevogacao(nroProcesso: string, titulares: Titular[], form: any): OrdemRevogacao {
    const base = this.buildBase(nroProcesso, titulares, form, TipoOrdem.REVOGACAO);
    return {
      ...base,
      dadosOrdem: {
        nomeAutor: form.autor,
        nomeReu: form.reu,
        descricaoOrdem: OrdemBuilderService.DESCRICAO_REVOGACAO
      }
    };
  }

  public buildOutros(nroProcesso: string, titulares: Titular[], form: any, arquivo: Arquivo): OrdemOutros {
    const base = this.buildBase(nroProcesso, titulares, form, TipoOrdem.OUTROS);
    return {
      ...base,
      dadosOrdem: {
        arquivo,
        descricaoOrdem: form.descricaoOrdem
      }
    };
  }

  private buildBase(nroProcesso: string, titulares: Titular[], form: any, tipoOrdem: TipoOrdem): Ordem {
    return {
      numeroProcesso: nroProcesso,
      titulares: this.processarTitulares(titulares, tipoOrdem),
      horasSla: form.nroSla,
      tipoOrdem
    };
  }

  public processarTitulares(titulares: Titular[], tipoOrdem: TipoOrdem): Titular[] {
    if (tipoOrdem === TipoOrdem.ACAO && titulares.length > 0) {
      return titulares.map((titular, index) => ({
        ...titular,
        principal: index === 0
      }));
    }
    return titulares;
  }
}
